<template>
  <div class="cbg-auth-message">
    <p class="cbg-auth-message__title">{{messageData.title}}</p>
    <p class="cbg-auth-message__description" :class="{'cbg-auth-message__description_center': step !== 2}" v-html="messageData.description"></p>
    <button v-if="step === 5" class="cbg-auth-message__button_back" @click="messageData.handler">
      <Svg class-name="cbg-auth-message__button-ico" icon-id="#arrow-left"/>
      <span class="cbg-auth-message__button-text">Go Back</span>
    </button>
    <button v-else-if="step === 6" class="cbg-auth__form-button" @click="messageData.handler">
      <span class="cbg-auth__form-button__text">Log In</span>
      <Svg class-name="cbg-auth__form-button__ico" icon-id="#log-in"/>
    </button>
    <button v-else class="cbg-auth-message__button" @click="messageData.handler">Thank you, got it</button>
  </div>
</template>

<script>
import {ContextUpdateSymbol, ContextStateSymbol} from '../../global/Context.vue';
import Svg from "@/components/global/Svg.vue";
export default {
  name: 'AuthMessage',
  components: {Svg},
  computed: {
    messageData() {
      let title, description, handler;

      if (this.step === 5) {
        const prevStep = this.isAuth ? 1 : 0;
        title = 'Oops!';
        description = 'Something went wrong.<br>Sorry for the inconvenience. Please try again later.';
        handler = () => this.updateStep(prevStep);
      } else if (this.step === 6) {
        title = 'Thank you!';
        description = 'Account verification has been successfully completed. You can continue with log in.';
        handler = () => {
          this.updateStep(0);
        };
      } else {
        if (this.email) {
          title = 'Check email';
          description = `In the next 15 minutes, you'll receive an email sent to your ${this.securedMail} account. When the email arrives, open it and follow the link.`;
          handler = () => {
            this.updateStep(0);
            this.updateContext && this.updateContext('isOpen', false);
          };
        } else {
          title = 'Thank you!';
          description = 'To confirm your account, you must click the link we have sent to your email. You may need to check spam or junk too.';
          handler = () => {
            this.updateStep(0);
            this.updateContext && this.updateContext('isOpen', false);

            if (/\/register\/?$/.test(window.location.pathname)) {
              const newUrl = window.location.pathname.replace(/\/register\/?$/, '/');
              history.replaceState(null, '', newUrl);
            }
          };
        }
      }

      return {
        title,
        description,
        handler,
      };
    },

    securedMail() {
      const [username, domain] = this.email.split('@');

      const encryptedUsername = username.length > 3
          ? username.substring(0, 3) + '*'.repeat(username.length - 3)
          : username.charAt(0) + '*'.repeat(username.length - 1);

      return `${encryptedUsername}@${domain}`;
    },
    step() {
      return this.context ? this.context.step : null;
    },
    isAuth() {
      return this.context ? this.context.isAuth : null;
    },
    email() {
      return this.context ? this.context.email : null;
    },
  },
  inject: {
    updateContext: { from: ContextUpdateSymbol, default: null },
    context: { from: ContextStateSymbol, default: null },
  },
  methods: {
    updateStep(value) {
      this.updateContext && this.updateContext('step', value);
    },
  },
  beforeUnmount() {
    this.updateContext && this.updateContext('email', null);
  }
}
</script>